import axios from "axios";
// export const url =
//   'https://41bf-2405-201-5019-c10b-c821-28cf-e41b-d1d2.ngrok-free.app';

export const url = "https://p08y9ui5n5.execute-api.us-east-2.amazonaws.com/test";

// export const url = "http://localhost:5001";

// export const url = "https://backend.wannabae.com";

const token = localStorage.getItem("authorization");
export default axios.create({
  baseURL: url,
  headers: {
    "Content-Type": "application/json",
    Authorization: JSON.parse(token),
  },

  // baseURL: "https://lexpedia-rest-api.herokuapp.com/api/v1",
});


export const SOCKET_URL = "https://qaapi.wannabae.com:5443";

// baseURL: "http://3.110.217.18:5000"
